import { IInputLoqateValue } from '@common/general-ui/input-loqate/input-loqate.component';
import { useField } from '@common/hooks/use-field.hook';
import React, { useCallback } from 'react';
import { GetAddressIO, IGetAddressIOProps, IInputLoqateChangeHandler } from './get-address-io.component';

export function FormGetAddressIO<TFormValues>(
    props: Omit<IGetAddressIOProps<keyof TFormValues>, 'value' | 'defaultValue'>,
): JSX.Element {
    const { onChange, getCustomErrorMessage } = props;
    const {
        setFieldValue,
        value,
        errorMessage,
        setFieldTouched: setFieldTouched,
    } = useField<IInputLoqateValue>({
        ...props,
        getCustomErrorMessage,
    });

    const handleChange = useCallback<IInputLoqateChangeHandler>(
        (e) => {
            setFieldValue(e.value);
            onChange && onChange(e);
            setFieldTouched();
        },
        [onChange, setFieldTouched, setFieldValue],
    );
    return (
        <GetAddressIO
            errorMessage={errorMessage}
            {...props}
            onChange={handleChange}
            name={props.name as string}
            defaultValue={value}
            value={value}
        />
    );
}
